import { render, staticRenderFns } from "./SustainabilityPage.vue?vue&type=template&id=6103e1e8&scoped=true&"
import script from "./SustainabilityPage.vue?vue&type=script&lang=js&"
export * from "./SustainabilityPage.vue?vue&type=script&lang=js&"
import style0 from "./SustainabilityPage.vue?vue&type=style&index=0&id=6103e1e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6103e1e8",
  null
  
)

export default component.exports